import { render } from "./PasswordWebsites.vue?vue&type=template&id=b0d08692&scoped=true"
import script from "./PasswordWebsites.vue?vue&type=script&lang=js"
export * from "./PasswordWebsites.vue?vue&type=script&lang=js"

import "./PasswordWebsites.vue?vue&type=style&index=0&id=b0d08692&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d08692"]])

export default __exports__